import getGames from "./getGames"
import startWebSocket from "./startWebSocket"
import lookBack from "./lookBack"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = { getGames, startWebSocket, lookBack }
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
const getGamesThunk = getGames.thunk
const startWebSocketThunk = startWebSocket.thunk
const lookBackThunk = lookBack.thunk
export {
  getGamesThunk as getGames,
  startWebSocketThunk as startWebSocket,
  lookBackThunk as lookBack,
}
